<ion-header>
  <ion-toolbar>
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">Schließen</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p class="ion-text-wrap">{{ message }}</p>

  <div class="btns">
    <ion-button expand="block" fill="outline" (click)="cancel()">
      {{ noLabel }}
    </ion-button>

    <ion-button
      expand="block"
      [color]="danger ? 'danger' : 'primary'"
      (click)="confirm()">
      {{ yesLabel }}
    </ion-button>
  </div>
</ion-content>
